import { TOptions } from 'i18next'
import { TTranslationsKeys, i18n } from '@ads/front-core/locales'

export const lng = (
  translation: TTranslationsKeys,
  options?: TOptions,
): string => {
  return i18n.t(translation, options)
}
